export const ROUTE_ERROR_TEXT = {
  default: 'An unexpected error occurred.',
  chunkLoadError: {
    message: 'Failed to fetch dynamically imported module',
    name: 'ChunkLoadError',
    actionText: 'Updating application.',
    subActionText: 'The page will refresh automatically.',
    sessionStorageKey: 'chunk-reload',
  },
};
